import React from 'react';

import { Button, ButtonTypeMap, SxProps, Theme } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';

import styles from './icon-text-button.module.scss';

type Props<T extends React.ElementType> = {
  DefaultIcon: React.ElementType;
  HoverIcon?: React.ElementType;
  link: {
    component: T;
    props: OverrideProps<ButtonTypeMap, T>;
    isExternal?: boolean;
  };
  sx?: SxProps<Theme>;
};

/**
 * A text button including an icon with support for an optional `HoverIcon`.
 */
export const IconTextButton = <T extends React.ElementType>({
  children,
  DefaultIcon,
  HoverIcon,
  link,
  sx,
}: React.PropsWithChildren<Props<T>>) => (
  <Button
    component={link.component}
    {...link.props}
    disableRipple
    variant="text"
    sx={sx}
    className={styles.iconTextButton}
    startIcon={
      <>
        <DefaultIcon className={HoverIcon ? styles.defaultIcon : undefined} />
        {HoverIcon && <HoverIcon className={styles.hoverIcon} />}
      </>
    }
  >
    {children}
  </Button>
);
